var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatDocIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18,
    r: 18,
    fill: "#FDE8EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.5 16.19H24.61C22.24 16.19 20.31 14.26 20.31 11.89V9C20.31 8.45 19.86 8 19.31 8H15.07C11.99 8 9.5 10 9.5 13.57V22.43C9.5 26 11.99 28 15.07 28H22.93C26.01 28 28.5 26 28.5 22.43V17.19C28.5 16.64 28.05 16.19 27.5 16.19Z",
    fill: "#ED1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8002 8.20999C22.3902 7.79999 21.6802 8.07999 21.6802 8.64999V12.14C21.6802 13.6 22.9202 14.81 24.4302 14.81C25.3802 14.82 26.7002 14.82 27.8302 14.82C28.4002 14.82 28.7002 14.15 28.3002 13.75C26.8602 12.3 24.2802 9.68999 22.8002 8.20999Z",
    fill: "#ED1C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5299 18.47L16.5299 16.47C16.5199 16.46 16.5099 16.46 16.5099 16.45C16.4499 16.39 16.3699 16.34 16.2899 16.3C16.2799 16.3 16.2799 16.3 16.2699 16.3C16.1899 16.27 16.1099 16.26 16.0299 16.25C15.9999 16.25 15.9799 16.25 15.9499 16.25C15.8899 16.25 15.8199 16.27 15.7599 16.29C15.7299 16.3 15.7099 16.31 15.6899 16.32C15.6099 16.36 15.5299 16.4 15.4699 16.47L13.4699 18.47C13.1799 18.76 13.1799 19.24 13.4699 19.53C13.7599 19.82 14.2399 19.82 14.5299 19.53L15.2499 18.81V23C15.2499 23.41 15.5899 23.75 15.9999 23.75C16.4099 23.75 16.7499 23.41 16.7499 23V18.81L17.4699 19.53C17.6199 19.68 17.8099 19.75 17.9999 19.75C18.1899 19.75 18.3799 19.68 18.5299 19.53C18.8199 19.24 18.8199 18.76 18.5299 18.47Z",
    fill: "#ED1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDocIcon);
export default __webpack_public_path__ + "static/media/chat-doc-icon.b1fc9449ad5d9b5a24c55cde257adf54.svg";
export { ForwardRef as ReactComponent };